module.exports = __webpack_public_path__ + "img/defaultuser.c9bf36e9.png";